export const SUBSCRIPTION_BILLING_ITEMS_PER_PAGE = 'abonnement-facturation-items-per-page'
export const SUBSCRIPTION_SUBSCRIBERS_ITEMS_PER_PAGE = 'abonnement-abonnes-items-per-page'
export const SUBSCRIPTION_TEAMS_ITEMS_PER_PAGE = 'abonnement-teams-items-per-page'
export const SUBSCRIPTION_PROJECTS_ITEMS_PER_PAGE = 'abonnement-projet-cours-items-per-page'
export const SUBSCRIPTION_CLOSED_PROJECTS_ITEMS_PER_PAGE = 'abonnement-project-closed-items-per-page'
export const SUBSCRIPTION_DR_PLAN_HISTORY_ITEMS_PER_PAGE = 'abonnement-data-room-forfait-history-items-per-page'
export const SUBSCRIPTION_DR_PPU_ITEMS_PER_PAGE = 'abonnement-data-room-ppu-items-per-page'
export const SUBSCRIPTION_DR_PPU_HISTORY_ITEMS_PER_PAGE = 'abonnement-data-room-ppu-history-items-per-page'
